export default {
  name: 'CookiesPage',
  data() {
    return {
      cookiesText: '',
      loading: false,
      error: '',
    };
  },
  mounted() {
    this.loadCookies();
  },
  methods: {
    async loadCookies() {
      this.loading = true;
      this.error = '';

      this.$store.getters.axl.post('profiles/api/register/page', { page: 'politika-ispolzovaniya-faylov-cookie-samurai' })
        .then(async (response) => {
          this.cookiesText = response.data.page;
          this.loading = false;
        })
        .catch(async (error) => {
          console.error('Ошибка загрузки:', error);
          this.error = 'Не удалось загрузить документ';
          this.cookiesText = this.getFallbackText();
          this.loading = false;
        });
    },

    getFallbackText() {
      return `
        <p>Не удалось загрузить документ.</p>
        <p>Пожалуйста, ознакомьтесь с документом по
          <a href="https://wheel.promo-online.pro/politika-ispolzovaniya-faylov-cookie-samurai">ссылке</a>
        </p>
      `;
    },
  },
};
